import React from 'react';
import PropTypes from 'prop-types';

const Heading = ({ name, tstyle='' }) => {
  return (
    <h1 className={`text-2xl font-bold text-gray-800 font-sans md:text-3xl ${tstyle}`}>
      {name}
    </h1>
  );
};

Heading.propTypes = {
  name: PropTypes.string.isRequired,
  tstyle: PropTypes.string,
};


export default Heading;
